import React, { useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import { animateHeadingBox } from "../../../utils/animations";

const HeadingBox = ({ title, description, textColor }) => {
  const wrapperRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);

  useEffect(() => {
    return animateHeadingBox(wrapperRef, titleRef, descriptionRef);
  }, []);

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <h1 
        ref={titleRef} 
        className={styles.title}
        style={textColor ? { color: textColor } : undefined}
      >
        {title}
      </h1>
      <p 
        ref={descriptionRef} 
        className={styles.description}
        style={textColor ? { color: textColor } : undefined}
      >
        {description}
      </p>
    </div>
  );
};

export default HeadingBox;
